import { SetStorageType } from './storage.type'

export const setStorageItem = ({ value, key }: SetStorageType): void => localStorage.setItem(key, value)

export const getStorageItem = (key: string): string | null => localStorage.getItem(key)

export const clearStorageItem = (key: string): void => localStorage.removeItem(key)
